import { createSlice } from "@reduxjs/toolkit";
import { INotificationDeviceFilterState } from "../types";
import { initialGeoRegion } from "../../../components/helpers";
import {
    setGeoRegionAction,
    setGroupKeyAction,
    setIsNotificationDeviceAssociationProgressAction,
    setSiteGroupAction,
    setAddDeviceGeoRegionAction,
    setAddDeviceSiteGroupAction,
    setIsAssociatedDevicesRemovedAction,
    resetFiltersAction,
    resetAddDeviceFiltersAction,
} from "./NotificationDeviceFilterActions";

const initialState: INotificationDeviceFilterState = {
    groupKey: { text: "System Default", value: "NONE" },
    isNotificationDeviceAssociationProgress: false,
    geoRegion: initialGeoRegion,
    addDeviceGeoRegion: initialGeoRegion,
    siteGroup: "",
};

const NotificationDeviceFilterSlice = createSlice({
    name: "notificationDeviceFilter",
    initialState,
    reducers: {
        setGroupKey: setGroupKeyAction,
        setIsNotificationDeviceAssociationProgress: setIsNotificationDeviceAssociationProgressAction,
        setSiteGroup: setSiteGroupAction,
        setAddDeviceSiteGroup: setAddDeviceSiteGroupAction,
        setGeoRegion: setGeoRegionAction,
        setAddDeviceGeoRegion: setAddDeviceGeoRegionAction,
        setIsAssociatedDevicesRemoved: setIsAssociatedDevicesRemovedAction,
        setResetFilters: resetFiltersAction,
        setResetAddDeviceFilters: resetAddDeviceFiltersAction,
    },
});

export const NotificationDeviceFilterReducer = NotificationDeviceFilterSlice.reducer;
export const {
    setGroupKey,
    setIsNotificationDeviceAssociationProgress,
    setSiteGroup,
    setAddDeviceSiteGroup,
    setGeoRegion,
    setAddDeviceGeoRegion,
    setIsAssociatedDevicesRemoved,
    setResetFilters,
    setResetAddDeviceFilters,
} = NotificationDeviceFilterSlice.actions; 